// リーグのプレイヤー選択（抜け番候補を含め play_type〜MAX_SESSION_PLAYERS 人まで選択可、play_type 超過時に確定でモーダルを開き play_type に絞る）
$(document).on('turbolinks:load', function () {
  const $list = $('.league-players-list');
  const $button = $('#league_players_select_btn');
  if ($list.length === 0 || $button.length === 0) return;

  const playerSelectModal = window.PlayerSelectModal ? new window.PlayerSelectModal() : null;

  const min = Number($list.data('min')) || 0; // 下限: play_type
  const max = Number($list.data('max')) || min; // 上限: HAMLから渡されるMAX_SESSION_PLAYERS（現在12人）

  const $form = $button.closest('form');
  const $counter = $('.player-selected-count');

  function getChecked() {
    return $("input[name='player_ids[]']:checked");
  }

  function getCheckedCount() {
    return getChecked().length;
  }

  function updateCounter() {
    $counter.text(getCheckedCount());
  }

  function updateButtonActivation() {
    const c = getCheckedCount();
    if (c >= min && c <= max) {
      $button.prop('disabled', false).removeClass('inactive');
    } else {
      $button.prop('disabled', true).addClass('inactive');
    }
  }

  function syncHiddenForCard($card) {
    const checked = $card.find("input[name='player_ids[]']").prop('checked');
    $card.find("input.participant-id, input.participant-name").prop('disabled', !checked);
  }

  function syncAllHidden() {
    $('.league-player-card').each(function () {
      syncHiddenForCard($(this));
    });
  }

  // 初期状態の反映
  updateCounter();
  updateButtonActivation();
  // 初期は全て無効 -> チェック済みがあれば有効化
  syncAllHidden();

  // 上限チェック（チェックしようとしたときに超える場合は拒否）
  $(document).on('change', "input[name='player_ids[]']", function (e) {
    const c = getCheckedCount();
    if (c > max) {
      // 直前の操作を取り消す
      $(this).prop('checked', false);
      alert($list.data('limit-reached'));
    }
    updateCounter();
    updateButtonActivation();
    // チェンジされたカードに対応する hidden を同期
    syncHiddenForCard($(this).closest('.league-player-card'));
  });

  // 決定ボタンクリック時の制御
  $button.on('click', function (e) {
    const count = getCheckedCount();
    if (count < min) {
      e.preventDefault();
      alert(window.Janreco.pluralize($list.data('min-players-template'), min));
      return;
    }

    // play_type を超えて選択時はモーダルで play_type 人に絞る（count === min はそのまま直接送信）
    if (count > min) {
      e.preventDefault();
      if (!playerSelectModal) return;

      const items = [];
      getChecked().each(function () {
        const id = Number($(this).val());
        const labelSelector = `label[for="${$(this).attr('id')}"] .league-player-name`;
        const name = $(labelSelector).first().text().trim();
        items.push({ id: id, name: name });
      });

      playerSelectModal.open({
        items: items,
        limit: min,
        title: $list.data('modal-title'),
        onConfirm: function (selectedIds, _selectedNames) {
          // 送信用に hidden inputs を再構築
          // 既存のチェックは外して送信対象を hidden に限定する
          $("input[name='player_ids[]']").prop('checked', false);
          $form.find('input[type=\"hidden\"][name=\"player_ids[]\"], input[type=\"hidden\"][name=\"participant_ids[]\"], input[type=\"hidden\"][name=\"participant_names[]\"]').remove();
          selectedIds.forEach(function (id) {
            $form.append($('<input>', { type: 'hidden', name: 'player_ids[]', value: id, autocomplete: 'off' }));
          });
          // モーダルに表示されていた参加者全員を participants として送る
          items.forEach(function (it) {
            const pid = it.id;
            const pname = it.name;
            $form.append($('<input>', { type: 'hidden', name: 'participant_ids[]', value: pid, autocomplete: 'off' }));
            $form.append($('<input>', { type: 'hidden', name: 'participant_names[]', value: pname, autocomplete: 'off' }));
          });
          $form.get(0).submit();
        }
      });
    }
    // count === min の場合はそのまま submit（既存のチェック値で送信）
    // 念のため submit 前に hidden 同期（disabledなものは送信されない）
    syncAllHidden();
  });
});

